import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SelectElement} from '../../../../../../components/common/select/select.model';
import {WorkflowTaskTriggerType} from '../../../../../workflow/task/api/model/trigger/workflowTaskTrigger.model';
import {MomentAdapter} from '../../../../../../shared/utils/moment.utils';
import {EmailActionSendService} from '../../service/send/emailActionSend.service';
import {BaseView} from '../../../../../core/view/base.view';
import {EmailSendPayload} from '../../service/send/emailSend.payload';
import {ObjectUtils} from '../../../../../../shared/utils/object.utils';
import {ActionDefaultComponent} from "../../../../../core/component/action-default/action-default.component";
import {AbstractActionService} from "../../../../../core/service/v2/service/action/abstractAction.service";
import {
  WithReportFormatContentPayload
} from "../../../../../reporting/report/impl/service/payload/withReportFormatContent.payload";

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  providers: [
    EmailActionSendService
  ]
})
export class SendEmailComponent extends BaseView implements OnInit, OnChanges {

  @Input() initialTo: string;
  @Input() initialSubject: string;
  @Input() initialContent: string;
  @Input() canAddDocuments = false;
  @Input() partnerId: number;
  @Input() hideSendButton = false;
  @Input() formatContentService: AbstractActionService<WithReportFormatContentPayload, any>;
  @Input() buildFormatContentPayload: () => WithReportFormatContentPayload;
  @Input() substitutionAdditionalCategoryValues: string [] = [];
  @ViewChild('actionDefault') actionDefault: ActionDefaultComponent<any>;
  formGroup: FormGroup;
  constructor(private formBuilder: FormBuilder,
              public service: EmailActionSendService) {
    super();
    this.formGroup = this.formBuilder.group({
      trigger: new FormGroup({}),
      partnerId: new FormControl(undefined),
    });
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['partnerId']) {
      this.formGroup.patchValue({
        partnerId: this.partnerId
      });
    }
  }

  buildPayload = (): EmailSendPayload => {
    return ObjectUtils.assign(new EmailSendPayload(), this.formGroup.value);
  }

  get triggerFormGroup(): FormGroup {
    return this.formGroup.get('trigger') as FormGroup;
  }

  actionDone() {
    this.toastControl.presentConfirmation(this.triggerFormGroup.get('time') ? 'L\e-mail a été programmé' : 'L\'e-mail a été envoyé');
  }
  send() {
    this.actionDefault.doAction();
  }
}
